// Dragon tiles that have no workflows ready behind them yet. A tile launches by
// being removed from this list.
export const COMING_SOON_TILE_SLUGS: readonly string[] = ["subscribe"];

export function isComingSoonTile(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return COMING_SOON_TILE_SLUGS.includes(slug);
}

// Elevated viewers keep full access, so a gated tile is only "coming soon" for
// everyone else.
export function isComingSoonForViewer(
  slug: string | null | undefined,
  hasElevatedAccess: boolean,
): boolean {
  return !hasElevatedAccess && isComingSoonTile(slug);
}
